import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoDirective } from '@jsverse/transloco';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { Textarea } from '@openng/optimus-ui/textarea';
import { FieldWrapperProps } from '../../wrappers/field-wrapper/field-wrapper.component';

interface TextAreaProps extends FieldWrapperProps {
  rows?: number;
  cols?: number;
}

export interface TextAreaFieldConfig extends FormlyFieldConfig<TextAreaProps> {
  type?: 'textarea' | Type<TextAreaTypeComponent>;
}

@Component({
  selector: 'lib-text-area-type',
  templateUrl: './text-area-type.component.html',
  styleUrl: './text-area-type.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, ReactiveFormsModule, Textarea, NgClass, FormlyModule]
})
export class TextAreaTypeComponent extends FieldType<FieldTypeConfig<TextAreaProps>> {}
